<template>
  <div class="card">
    <div class="card-header">
      <p class="text-sm font-normal text-gray-500 mb-4" v-html="questionText"></p>
    </div>
    <div class="block lg:flex">
      <div class="w-full">
        <h2 class="text-sm lg:text-base font-semibold mb-2">{{ __('test.selfcontrol.yours') }}:</h2>
        <p class="text-sm lg:text-base">{{ givenAnswer }}</p>
      </div>
      <hr class="block lg:hidden my-5">
      <div class="w-full">
        <h2 class="text-sm lg:text-base font-semibold mb-2">{{ __('test.selfcontrol.correct') }}:</h2>
        <p class="text-sm lg:text-base" v-html="correctAnswer"></p>
      </div>
    </div>

    <hr class="my-5">
    <div class="card-footer flex justify-between lg:justify-end gap-4">
      <button class="btn btn-success" @click="setSelfcontrol(1)"><i class="fa fa-thumbs-up mr-2"></i> {{ __('general.right') }}</button>
      <button class="btn btn-danger" @click="setSelfcontrol(0)"><i class="fa fa-thumbs-down mr-2"></i> {{ __('general.wrong') }}</button>
    </div>
  </div>
</template>

<script>
import { sendAnswer } from '../../api/QuestionApi'
import {sendMistakeAnswer} from '../../api/MistakeApi'

export default {
  name: 'FreetextSelfcheck',

  props: {
    exam: {
      type: Object,
      required: false,
    },
    test: {
      type: Object,
      required: false,
    },
    mistakeId: {
      type: Number,
      required: false,
    },
    /**
     * Given answer contains all information for the self check
     */
    givenAnswer: {
      type: String,
      required: true,
    },
    questionId: {
      type: Number,
      required: false,
    },
    /**
     * the correct answer was precalculated
     */
    correctAnswer: {
      type: String,
      required: true,
    },
    questionText: {
      type: String,
      required: false,
    },
    /**
     * Decides, which request to make
     */
    type: {
      type: String,
      required: false,
      default: 'exam',
    },
  },
emits: ['setAnswer', 'answered'],

  data() {
    return {
      answer: null,
    }
  },

  methods: {
    setSelfcontrol: async function( answer ) {

      let data = {
        type: this.type ?? null,
        exam_id: this.exam ? this.exam.id : null,
        test_id: this.test ? this.test.id : null,
        mistake_id: this.mistakeId ?? null,
        question_id: this.questionId,
        answer: answer,
        is_missed: false,
        is_selfcontrol: true,
      }

      let results = await this.sendDependingOnType( data )
      this.$emit('answered', results )
    },

    async sendDependingOnType( data ) {
      if( this.type === 'mistakes' ) {
        return await sendMistakeAnswer( data )
      } else {
        return await sendAnswer( data )
      }
    },
  },

}
</script>

<style scoped>

</style>
